import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import { AuthProvider } from "@/context/AuthContext";
import { MemberAuthProvider } from "@/context/MemberAuthContext";
import Home from "@/pages/Home";
import OfficeBearers from "@/pages/OfficeBearers";
import Districts from "@/pages/Districts";
import DistrictDetail from "@/pages/DistrictDetail";
import GRNotices from "@/pages/GRNotices";
import Gapl from "@/pages/Gapl";
import Advertise from "@/pages/Advertise";
import Contact from "@/pages/Contact";
import ContentPage from "@/pages/ContentPage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import { ProtectedRoute } from "@/pages/admin/ProtectedRoute";
import MemberLogin from "@/pages/member/MemberLogin";
import MemberDashboard from "@/pages/member/MemberDashboard";
import MemberReceipt from "@/pages/member/MemberReceipt";
import RequestAccess from "@/pages/member/RequestAccess";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <MemberAuthProvider>
          <LanguageProvider>
            <BrowserRouter>
              <ScrollToTop />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<ContentPage slug="about" />} />
                <Route path="/office-bearers" element={<OfficeBearers />} />
                <Route path="/constitution" element={<ContentPage slug="constitution" />} />
                <Route path="/districts" element={<Districts />} />
                <Route path="/districts/:slug" element={<DistrictDetail />} />
                <Route path="/gr-notices" element={<GRNotices />} />
                <Route path="/gapl" element={<Gapl />} />
                <Route path="/advertise" element={<Advertise />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/legal/:doc" element={<ContentPage />} />
                <Route path="/privacy" element={<ContentPage slug="privacy" />} />
                <Route path="/terms" element={<ContentPage slug="terms" />} />
                <Route path="/refund-policy" element={<ContentPage slug="refund" />} />
                <Route path="/refund" element={<ContentPage slug="refund" />} />
                <Route path="/cancellation" element={<ContentPage slug="refund" />} />
                <Route path="/ad-policy" element={<ContentPage slug="ad-policy" />} />
                <Route path="/p/:slug" element={<ContentPage />} />
                <Route path="/member/login" element={<MemberLogin />} />
                <Route path="/member" element={<MemberDashboard />} />
                <Route path="/member/receipt/:id" element={<MemberReceipt />} />
                <Route path="/request-access" element={<RequestAccess />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
              </Routes>
            </BrowserRouter>
          </LanguageProvider>
        </MemberAuthProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
